// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const nameIDReportSchema = z.object({
  "data": z.array(z.object({
    "eligibility_error": z.string().optional(),
    "application_id": z.string().uuid(),
    "application_name": z.string(),
    "format": z.string(),
    "source": z.string(),
    "sends": z.enum(["internal_id", "transient", "email", "employee_number", "custom_field", "tenant_attribute"]),
    "held_unique": z.boolean(),
    "released_at": z.enum(["never", "record_deleted", "departure", "not_held"]),
    "duplicate_values": z.number().int(),
    "users_without_value": z.number().int()
  })),
  "departed_employee_number_collisions": z.number().int()
});
